import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import SigningcontractImage from 'assets/images/SigningcontractImage.png';
import CustomStepperAgent from 'component/BannerComponents/AgentBanners/CustomStepperAgent';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { getApiCall } from 'api/apiService';
import { API_URL, REQUEST_SIGN_TEMPLATE } from 'constant/app.config';
import CommenceESignDialog from 'component/BuyersMarketplace/CommenceESignDialog';

const SignNowIcon = ({ disableColor }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 28 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 25C6.09753 22 8.64706 19 8.64706 16C8.64706 11.5 7.11765 11.5 5.58824 11.5C4.05882 11.5 2.48047 13.1275 2.52941 16C2.58141 19.072 5.06518 20.3155 6.35294 22C8.64706 25 10.1765 25.75 11.7059 23.5C12.726 22 13.4907 20.7505 14 19.75C15.5294 23.2495 17.5681 25 20.1176 25H23.9412"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.0005 22V4C27.0005 2.3185 25.6561 1 23.9416 1C22.2272 1 20.8828 2.3185 20.8828 4V22L23.9416 25L27.0005 22Z"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.8828 7H27.0005"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Step3ESignReceivedSignNowBannerBuyer = (props) => {
  const {
    isBuyerDashboard,
    getBuyerIndividualValue,
    buyerDashboardDetails,
    groupCall,
    DashboardGroupCall,
  } = props;
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const [openESign, setOpenESign] = useState(false);
  const [pdfMeta, setPdfMeta] = useState(null);
  const params = useParams();
  const dataa = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(dataa);

  const handleCommenceEsignOpen = async () => {
    try {
      const propertyId = isBuyerDashboard
        ? Number(buyerDashboardDetails?.property?.propertyId)
        : params?.propertyId;

      const response = await getApiCall(
        `${REQUEST_SIGN_TEMPLATE}?propertyId=${propertyId}`
      );

      if (response?.data?.status === 1) {
        const { contractFile, fields } = response.data;

        setPdfMeta({
          contractFile,
          fields,
        });

        setOpenESign(true);
      }
    } catch (error) {
      console.error('Failed to fetch sign template', error);
    }
  };
  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: 'rgba(33, 132, 253, 0.8)',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '0 0 20px 0' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container xs={12} md={12}>
          <Grid item container xs={12} md={9}>
            <Grid item xs={12}>
              <Stack
                direction={'column'}
                padding={matchessm ? '10px 10px 0 10px' : '30px 0 0 33px'}
              >
                <Typography
                  sx={{
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>
                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 1)',
                    fontFamily: 'poppins',
                    mt: !matchessm && '10px',
                  }}
                >
                  E-Sign Request Received - Sign Now
                </Typography>
                <Typography
                  sx={{
                    fontSize: matchessm ? '12px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    marginTop: matchessm ? '10px' : '10px',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  The contract of sale for &nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '12px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName ||
                      buyerDashboardDetails?.propertyAddress?.streetName}
                  </span>
                  &nbsp; is ready to sign. Please sign immediately to avoid
                  default. Buyer’s that fail to sign promptly can be in breach
                  of the terms and conditions and may face serious penalties and
                  or recovery action.
                </Typography>
              </Stack>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: 'flex',
                  justifyContent: matchessm ? 'space-between' : 'start',
                  gap: matchessm ? 1 : 2,
                  padding: matchessm ? '0 10px 0 10px' : '0 0 0 33px',
                }}
              >
                <Button
                  sx={{
                    px: 4,
                    height: matchessm ? 35 : 42,
                    borderRadius: '5px',
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: 'transparent',
                    color: '#E6F2FF',
                    fontFamily: 'poppins',
                    whiteSpace: 'nowrap',
                    fontWeight: 300,
                    '&:hover': {
                      bgcolor: 'rgb(33, 132, 253)',
                      color: '#E6F2FF',
                    },
                  }}
                >
                  View Details
                </Button>
                <Box display="flex" alignItems="center">
                  <Button
                    varient="contained"
                    onClick={handleCommenceEsignOpen}
                    startIcon={<SignNowIcon />}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: '#FFF',
                      fontWeight: 300,
                      color: '#2184FD',
                      fontFamily: 'poppins',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        bgcolor: 'rgb(248, 248, 248)',
                        color: 'rgb(33, 132, 253)',
                      },
                    }}
                  >
                    Sign Now
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} alignItems={'center'}>
                <CustomStepperAgent stepValue={2} requestEsign={true} />
              </Grid>
            </Grid>
          </Grid>
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={SigningcontractImage}
                alt="SigningcontractImage"
                style={{
                  objectFit: 'contain',
                  height: '257px',
                  width: '264px',
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
      {openESign && (
        <CommenceESignDialog
          open={openESign}
          onClose={() => setOpenESign(false)}
          pdfMeta={pdfMeta}
          streetName={
            isBuyerDashboard
              ? buyerDashboardDetails?.propertyAddress?.streetName
              : getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
          }
          matchessm={matchessm}
          userDetail={userDetail}
          propertyId={
            isBuyerDashboard
              ? buyerDashboardDetails?.property?.propertyId
              : params?.propertyId
          }
          getListInfo={isBuyerDashboard ? DashboardGroupCall : groupCall}
        />
      )}
    </>
  );
};

export default Step3ESignReceivedSignNowBannerBuyer;
